// src/utils/clearCachedData.js
// Utility to clear all cached data and force clean Firebase connection

export const clearAllCachedData = () => {
  try {
    // Clear localStorage
    localStorage.clear();
    
    // Clear sessionStorage
    sessionStorage.clear();
    
    // Clear any IndexedDB data (if used)
    if ('indexedDB' in window) {
      indexedDB.databases().then(databases => {
        databases.forEach(db => {
          indexedDB.deleteDatabase(db.name);
        });
      });
    }
    
    console.log('✅ All cached data cleared');
    return true;
  } catch (error) {
    console.error('❌ Error clearing cached data:', error);
    return false;
  }
};

export const forceFirebaseConnection = () => {
  // Force reload to ensure clean Firebase connection
  window.location.reload();
};

export const initializeCleanHealeHub = () => {
  console.log('🧹 Initializing clean HealeHub...');
  
  // Clear all cached data
  clearAllCachedData();
  
  // Set clean state flags
  localStorage.setItem('HEALEHUB_CLEAN_INIT', 'true');
  localStorage.setItem('HEALEHUB_SETUP_REQUIRED', 'true');
  
  // Force reload with clean state
  setTimeout(() => {
    forceFirebaseConnection();
  }, 1000);
};
